import { render, staticRenderFns } from "./order-form-tab.vue?vue&type=template&id=92250a04"
import script from "./order-form-tab.vue?vue&type=script&lang=js"
export * from "./order-form-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports